import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import { Modals } from "./components/modals";
import { Index } from "./pages";
 
function App() {
  return (
    <div className="">
      <Index />
      <Modals />
    </div>
  );
}

export default App;
